<section class="content system-log-detail-page">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.AUDIT.TEXT' | translate"
                      [items]="[('systemLogsCatalog.breadcrumb' | translate), ('systemLogsCatalog.detail.title' | translate)]" />
    </div>

    <main class="audit-detail">
      @if (isLoading) {
        <app-loading-state [overlay]="false" [message]="'systemLogsCatalog.loadingDetail' | translate" />
      } @else if (log; as item) {
        <header class="audit-hero">
          <div class="audit-hero__icon"><mat-icon>policy</mat-icon></div>
          <div class="audit-hero__copy">
            <span>{{ 'systemLogsCatalog.detail.eyebrow' | translate }}</span>
            <h1>{{ actionLabel }} · {{ modelLabel }}</h1>
            <p>{{ formatDate(item.occurredAt) }}</p>
          </div>
          <button mat-stroked-button type="button" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>{{ 'common.back' | translate }}
          </button>
        </header>

        <section class="audit-summary">
          <article><mat-icon>person</mat-icon><span>{{ 'systemLogsCatalog.fields.actor' | translate }}</span><strong>{{ actorLabel }}</strong><small>{{ item.actor?.via || item.source || '-' }}</small></article>
          <article><mat-icon>language</mat-icon><span>{{ 'systemLogsCatalog.fields.ip' | translate }}</span><strong>{{ item.actor?.ip || '-' }}</strong><small>{{ item.actor?.center || item.center || '-' }}</small></article>
          <article><mat-icon>category</mat-icon><span>{{ 'systemLogsCatalog.fields.module' | translate }}</span><strong>{{ item.moduleKey || '-' }}</strong><small>{{ item.model || '-' }}</small></article>
          <article><mat-icon>tag</mat-icon><span>{{ 'systemLogsCatalog.fields.recordId' | translate }}</span><strong class="audit-code">{{ item.recordId || '-' }}</strong><small>v{{ item.version || '-' }}</small></article>
        </section>

        <section class="audit-card">
          <div class="audit-card__header">
            <div>
              <span>{{ 'systemLogsCatalog.detail.changesEyebrow' | translate }}</span>
              <h2>
                @if (isSnapshotAction) {
                  {{ (isCreateAction ? 'systemLogsCatalog.detail.createdSnapshotTitle' : 'systemLogsCatalog.detail.deletedSnapshotTitle') | translate }}
                } @else {
                  {{ 'systemLogsCatalog.detail.changesTitle' | translate }}
                }
              </h2>
            </div>
            <span class="audit-count">{{ isSnapshotAction ? snapshotFieldCount : changes.length }}</span>
          </div>

          @if (isSnapshotAction) {
            <div class="audit-snapshot" [class.audit-snapshot--deleted]="!isCreateAction">
              <div class="audit-snapshot__toolbar">
                <div class="audit-snapshot__label">
                  <mat-icon>{{ isCreateAction ? 'add_circle' : 'delete' }}</mat-icon>
                  <div>
                    <strong>{{ (isCreateAction ? 'systemLogsCatalog.detail.createdSnapshot' : 'systemLogsCatalog.detail.deletedSnapshot') | translate }}</strong>
                    <span>{{ 'systemLogsCatalog.detail.snapshotDescription' | translate:{ count: snapshotFieldCount } }}</span>
                  </div>
                </div>
                <button mat-stroked-button type="button" (click)="copySnapshot()">
                  <mat-icon>content_copy</mat-icon>
                  {{ 'systemLogsCatalog.detail.copyJson' | translate }}
                </button>
              </div>
              <pre>{{ snapshotJson }}</pre>
            </div>
          } @else if (changes.length) {
            <div class="change-list">
              @for (change of changes; track $index) {
                <article class="change-row">
                  <div class="change-row__field"><span>{{ changeKind(change) }}</span><strong>{{ fieldPath(change) }}</strong></div>
                  <div class="change-value change-value--before"><span>{{ 'systemLogsCatalog.detail.before' | translate }}</span><pre>{{ displayValue(change.lhs) }}</pre></div>
                  <mat-icon class="change-row__arrow">arrow_forward</mat-icon>
                  <div class="change-value change-value--after"><span>{{ 'systemLogsCatalog.detail.after' | translate }}</span><pre>{{ displayValue(change.rhs) }}</pre></div>
                </article>
              }
            </div>
          } @else {
            <div class="audit-empty"><mat-icon>check_circle</mat-icon><span>{{ 'systemLogsCatalog.detail.noChanges' | translate }}</span></div>
          }
        </section>

        @if (hasTechnicalData()) {
          <details class="audit-card audit-technical">
            <summary><div><span>{{ 'systemLogsCatalog.detail.technicalEyebrow' | translate }}</span><strong>{{ 'systemLogsCatalog.detail.technicalTitle' | translate }}</strong></div><mat-icon>expand_more</mat-icon></summary>
            <div class="technical-grid">
              <div><span>Log ID</span><code>{{ item.logId }}</code></div>
              <div><span>Event ID</span><code>{{ item.eventId || '-' }}</code></div>
              <div><span>Correlation ID</span><code>{{ item.correlationId || '-' }}</code></div>
              <div><span>Idempotency key</span><code>{{ item.idempotencyKey || '-' }}</code></div>
              <div class="technical-grid__wide"><span>Ref</span><code>{{ item.ref || '-' }}</code></div>
              @if (item.metadata) { <pre class="technical-grid__wide">{{ item.metadata | json }}</pre> }
            </div>
          </details>
        }
      }
    </main>
  </div>
</section>
